// @flow
import * as React from 'react';
import {ReactFlowProvider} from 'react-flow-renderer';
import Group from 'sail/Group';

import {DiagramGeneratorProvider} from 'docs/data';
import {OnlyRenderOnClient} from 'docs/components';
import {DiagramGeneratorContent} from './DiagramGeneratorContent';
import type {DiagramType} from '../types';
import './DiagramGenerator.scss';

type DiagramGeneratorProps = {|
  type: DiagramType,
|};

export const DiagramGenerator = ({type}: DiagramGeneratorProps) => {
  return (
    <OnlyRenderOnClient>
      <Group margin={{top: 16}}>
        <ReactFlowProvider>
          <DiagramGeneratorProvider initialType={type}>
            <DiagramGeneratorContent />
          </DiagramGeneratorProvider>
        </ReactFlowProvider>
      </Group>
    </OnlyRenderOnClient>
  );
};
